import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { themeColors } from '../app/layout/theme'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h3" sx={{ fontWeight: 600, mb: 2, color: themeColors.text.primary }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ mb: 2, color: themeColors.text.secondary }}>
        Page Not Found
      </Typography>
      <Typography sx={{ mb: 4, color: themeColors.text.secondary }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        sx={{ backgroundColor: themeColors.primary }}
        onClick={() => navigate('/')}
      >
        Go to Home
      </Button>
    </Box>
  )
}
